import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import TextField from '../../molecules/fields/TextField'
import QuestionOptionsSection from './QuestionOptionsSection'
import * as validations from '../../../utils/validations'
import { useField } from 'react-final-form'
import * as uuid from 'uuid'

const RepeatGroupField = ({ baseName }) => {
  const alternatives = useField(`${baseName}.payload.alternatives`)
  const { input: hasSubQuestions } = useField(`${baseName}.has_sub_questions`)
  useEffect(() => {
    if (!alternatives.input.value) {
      alternatives.input.onChange([{ id: uuid.v4(), type: 'default', label: 'Preguntas a repetir' }])
      hasSubQuestions.onChange(true)
    }
  }, [alternatives])

  return (
    <div className="grid md:grid-cols-2 flex-wrap gap-4">
      <div>
        <TextField
          label="Etiqueta de la pregunta"
          margin="none"
          size="full"
          name={`${baseName}.payload.label`}
          initialValue=""
          capsLockInfo
          validate={validations.required()}
        />
        <QuestionOptionsSection baseName={baseName} size="full" />
        <TextField
          label="Cantidad a repetir"
          name={`${baseName}.payload.count`}
          max="10"
          min="2"
          margin="dense"
          type="number"
          validate={validations.mix(validations.required(), validations.isNumber())}
        />
        <TextField
          label="Texto de separación"
          name={`${baseName}.payload.separator_text`}
          margin="dense"
          validate={validations.required()}
        />
      </div>
    </div>
  )
}

export default RepeatGroupField

RepeatGroupField.propTypes = {
  baseName: PropTypes.string
}
